// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7527) return "static/chunks/7527-16342093f5790553.js";
	if (chunkId === 8629) return "static/chunks/8629-fa8cdf3800e723af.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"4b86cb2e5351eef9","2976":"770f52f5d649edd3","3756":"8a60e404cca42c43","9839":"998ca24939284ecf"}[chunkId] + ".js";
};